import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import MonitoringBadge from './MonitoringBadge';
import { LogOut, Menu, X, Wallet, Lock, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import ServiceGate from '../ServiceGate';
import { useNavAreas, useActiveIntoView, useSideCollapsed, LOGO } from './nav';
import { eur } from '../api';
import BackButton from './BackButton';

function Links({ onNavigate, prefix }) {
  const areas = useNavAreas();
  const navRef = useActiveIntoView();
  return (
    <nav ref={navRef} className="rs-nav side-scroll" data-testid={`${prefix}-list`}>
      {areas.map((a) => [a.label && <p key={`h-${a.id}`} className="nav-area rs-area" data-testid={`${prefix}-area-${a.id}`}>{a.label}</p>, a.sub && <p key={`s-${a.id}`} className="nav-sub rs-area" data-testid={`${prefix}-sub-${a.id}`}>{a.sub}</p>, ...a.items.map(({ to, icon: Icon, label, testid: id, key, end, locked }) => (
        <NavLink key={key} to={to} end={end} onClick={onNavigate} title={label} data-testid={`${prefix}-${id}`}
          className={({ isActive }) => `rs-link ${isActive ? 'active' : ''}`}>
          <Icon size={18} className="shrink-0" /><span className="rs-label flex-1">{label}</span>{id === 'monitoring' && !locked && <MonitoringBadge />}{locked && <Lock size={12} className="shrink-0 opacity-60" data-testid={`${prefix}-locked-${id}`} />}
        </NavLink>
      ))])}
    </nav>
  );
}

function LogoutBtn({ onLogout, testid }) {
  return (
    <button onClick={onLogout} aria-label="Esci" title="Esci" data-testid={testid}
      className="rs-link mt-2 hover:!text-[#F07A70]">
      <LogOut size={18} /><span className="text-sm">Esci</span>
    </button>
  );
}

export default function RossoShell({ user, onLogout, ctx }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setOpen(false);
  const [collapsed, toggle] = useSideCollapsed();
  return (
    <>
      <div className="portal-root rs-root" data-theme-active="rosso">
        <aside className={`rs-rail hidden lg:flex ${collapsed ? 'rs-collapsed' : ''}`} data-testid="portal-side">
          <div className="rs-head"><span className="rs-si">si</span>
            <button className="rs-toggle" onClick={toggle} title={collapsed ? 'Espandi menu' : 'Riduci menu'} aria-label={collapsed ? 'Espandi menu' : 'Riduci menu'} data-testid="portal-side-toggle">{collapsed ? <PanelLeftOpen size={17} /> : <PanelLeftClose size={17} />}</button></div>
          <Links onNavigate={() => {}} prefix="portal-nav" />
          <LogoutBtn onLogout={onLogout} testid="portal-logout" />
        </aside>
        {open && (
          <div className="fixed inset-0 z-50 lg:hidden">
            <div className="absolute inset-0 bg-black/70" onClick={close} />
            <aside className="rs-drawer">
              <img src={LOGO} alt="BOND" className="h-8 w-auto self-start mb-6" />
              <Links onNavigate={close} prefix="portal-drawer" />
              <LogoutBtn onLogout={onLogout} testid="portal-drawer-logout" />
            </aside>
          </div>
        )}
        <div className="flex-1 min-w-0 flex flex-col rs-main">
          <header className="rs-top">
            <BackButton className="lg:hidden text-[#C9CAD0]" />
            <button className="lg:hidden text-[#C9CAD0]" onClick={() => setOpen(!open)} data-testid="portal-mobile-menu">{open ? <X /> : <Menu />}</button>
            <img src={LOGO} alt="BOND" />
            <div className="ml-auto flex items-center gap-4 min-w-0">
              <div className="hidden md:block text-right min-w-0">
                <p className="text-sm text-[#EDEDEF] truncate" data-testid="portal-user-name">{user.name || user.email}</p>
                <p className="text-xs text-[#7C7F87] truncate">{user.company_name || user.email}</p>
              </div>
              <button className="rs-chip" onClick={() => navigate('/portal/plafond')} data-testid="portal-header-balance">
                <Wallet size={14} className="text-[#C0392B]" /> {eur(user.wallet_cents)}
              </button>
            </div>
          </header>
          <main className="flex-1 px-5 py-8 lg:px-10 lg:py-8 w-full" style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}>
            <div className={collapsed ? 'max-w-[1900px]' : 'max-w-[1500px]'}><ServiceGate ctx={ctx} /></div>
          </main>
        </div>
      </div>
    </>
  );
}
